import { OnChangeValue } from 'react-select';
import { StyledSubheader } from 'src/components/foundations/foundations.styles';
import { FormInputVariant, FormState } from 'src/types';
import {
  InviteUserDropdownOption,
  InviteUserOption,
} from '../../DropdownSelect';
import { FormInput } from '../../FormInput';
import { SearchFieldDescription } from '../InviteToCaseModal.styles';
import { DropdownContainer } from './PeopleStep.styles';

interface Props {
  availableTeamMembers: InviteUserDropdownOption[];
  selectedTeamMembers: InviteUserDropdownOption[];
  handleSelectTeamMembers: (
    optionsSelected: OnChangeValue<InviteUserDropdownOption, boolean>,
  ) => void;
}

export const PeopleStep = ({
  availableTeamMembers,
  selectedTeamMembers,
  handleSelectTeamMembers,
}: Props) => (
  <div>
    <StyledSubheader>Invite people to your case</StyledSubheader>
    <SearchFieldDescription>
      Expand your team by inviting individuals to collaborate on your case
    </SearchFieldDescription>
    <DropdownContainer>
      <FormInput<InviteUserDropdownOption>
        variant={FormInputVariant.DROPDOWN}
        placeholder="Search by name"
        state={FormState.DEFAULT}
        onChange={handleSelectTeamMembers}
        options={availableTeamMembers}
        components={{ Option: InviteUserOption }}
        isSearchable
        isMulti
        fuzzySearch
        value={selectedTeamMembers}
        menuHeight="365px"
        data-testid="invite-people-dropdown"
        menuPlacement="bottom"
      />
    </DropdownContainer>
  </div>
);
